const jwtDecode = require("jwt-decode");

export const isAdviser = (idToken) => {
    return typeof jwtDecode(idToken)["cognito:groups"] !== 'undefined' && (
        jwtDecode(idToken)["cognito:groups"].includes("Ginecologa") ||
        jwtDecode(idToken)["cognito:groups"].includes("Sexologa") ||
        jwtDecode(idToken)["cognito:groups"].includes("Psicologa") ||
        jwtDecode(idToken)["cognito:groups"].includes("Loving") ||
        jwtDecode(idToken)["cognito:groups"].includes("Konecta") ||
        jwtDecode(idToken)["cognito:groups"].includes("Administradora") ||
        jwtDecode(idToken)["cognito:groups"].includes("Calidad") ||
        jwtDecode(idToken)["cognito:groups"].includes("Publicadora") ||
        jwtDecode(idToken)["cognito:groups"].includes("Moderadora")
    );
};

export const isConsulting = (idToken) => {
    return typeof jwtDecode(idToken)["cognito:groups"] !== 'undefined' && (
        jwtDecode(idToken)["cognito:groups"].includes("Ginecologa") ||
        jwtDecode(idToken)["cognito:groups"].includes("Sexologa") ||
        jwtDecode(idToken)["cognito:groups"].includes("Loving") ||
        jwtDecode(idToken)["cognito:groups"].includes("Psicologa")
    );
};

export const isKonecta = (idToken) => {
    return typeof jwtDecode(idToken)["cognito:groups"] !== 'undefined' && (jwtDecode(idToken)["cognito:groups"].includes("Konecta"));
};

export const isGinecologa = (idToken) => {
    return typeof jwtDecode(idToken)["cognito:groups"] !== 'undefined' && (jwtDecode(idToken)["cognito:groups"].includes("Ginecologa"));
};

export const isSexologa = (idToken) => {
    return typeof jwtDecode(idToken)["cognito:groups"] !== 'undefined' && (jwtDecode(idToken)["cognito:groups"].includes("Sexologa"));
};

export const isLoving = (idToken) => {
    return typeof jwtDecode(idToken)["cognito:groups"] !== 'undefined' && (jwtDecode(idToken)["cognito:groups"].includes("Loving"));
};

export const isPsicologa = (idToken) => {
    return typeof jwtDecode(idToken)["cognito:groups"] !== 'undefined' && (jwtDecode(idToken)["cognito:groups"].includes("Psicologa"));
};

export const isAdmin = (idToken) => {
    return typeof jwtDecode(idToken)["cognito:groups"] !== 'undefined' && (jwtDecode(idToken)["cognito:groups"].includes("Administradora"));
};

export const isCalidad = (idToken) => {
    return typeof jwtDecode(idToken)["cognito:groups"] !== 'undefined' && (jwtDecode(idToken)["cognito:groups"].includes("Calidad"));
};

export const isPublisher = (idToken) => {
    return typeof jwtDecode(idToken)["cognito:groups"] !== 'undefined' && (jwtDecode(idToken)["cognito:groups"].includes("Publicadora"));
};

export const isModerator = (idToken) => {
    return typeof jwtDecode(idToken)["cognito:groups"] !== 'undefined' && (jwtDecode(idToken)["cognito:groups"].includes("Moderadora"));
};